<template>
  <BackgroundSlider>
    <p>
      <img width="200" src="~assets/logo.svg" :alt="description">
    </p>

    <h1 class="is-title is-bold" style="color:white">{{ name.replace('-', ' ') }}</h1>

    <p >
      <strong style="color:white">Stats Engine</strong>
      
    </p>
  </BackgroundSlider>

  
</template>

<script>
import BackgroundSlider from './ui/background_slider.vue'
export default {
  components: {
    BackgroundSlider
  },
  data () {
    return this.$store.state.pkg
  }
}
</script>

<style lang="scss" scoped>

.is-title {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// Home.vue?cdb695fa